import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { uploadQuestions } from "../../store/questionBank/action";
import { fileValidationSchema } from "./constants";
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";
import * as XLSX from "xlsx";

const QuestionImport = ({ toggle, modal }) => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState("");

  useEffect(() => {
    if (!modal) {
      setFiles([]);
      setFileError("");
    }
  }, [modal]);

  const handleFile = (fileItems) => {
    if (fileItems.length > 1) {
      setFileError("Please upload only a single file at a time.");
      return;
    }

    const fileItem = fileItems[0]?.file;

    fileValidationSchema
      .validate({ file: fileItem })
      .then(() => {
        setFileError("");
        setFiles([fileItem]);
      })
      .catch((error) => {
        setFileError(error.message || "Invalid file type.");
      });
  };

  function createExcelFile() {
    // Define the sample data
    const sampleData = [
      {
        QuestionTitle: "Test 1",
        difficulty: "Easy",
        level: "Entry",
        topic: "Java",
        question_Type: "MCQ",
        answers: JSON.stringify([
          { Options: ["Java", "Python"], Answers: ["Java"] },
        ]),
        Explanation: "",
        Technology: "",
      },
      {
        QuestionTitle: "Test 2",
        difficulty: "Medium",
        level: "Entry",
        topic: "Python",
        question_Type: "TF",
        answers: JSON.stringify([{ Answers: ["True"] }]),
        Explanation: "",
        Technology: "",
      },
      {
        QuestionTitle: "Test 3",
        difficulty: "Hard",
        level: "Entry",
        topic: "Java",
        question_Type: "FIB",
        answers: JSON.stringify([{ Answers: ["Java"] }]),
        Explanation: "",
        Technology: "",
      },
      {
        QuestionTitle: "Test 4",
        difficulty: "Easy",
        level: "Entry",
        topic: "Java",
        question_Type: "Descriptive",
        answers: JSON.stringify([{ Answers: ["Java"] }]),
        Explanation: "",
        Technology: "",
      },
    ];

    // Create a worksheet from the sample data
    const worksheet = XLSX.utils.json_to_sheet(sampleData);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Questions");

    // Write the workbook to a file
    XLSX.writeFile(workbook, "questionstemplate.xlsx");
  }

  const handleUploadFile = () => {
    if (files.length === 0) {
      toast.error("Please upload a file before proceeding.");
      return;
    }
    const formData = new FormData();
    formData.append("files", files[0]);
    dispatch(
      uploadQuestions({
        data: formData,
      })
    );
    toggle();
  };

  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle} />
      <ModalBody>
        <div className="d-flex justify-content-between align-items-baseline mb-2">
          <h4>Import Bulk Question</h4>
          <Button
            style={{ backgroundColor: "#3092d9", color: "white" }}
            onClick={createExcelFile}
          >
            Download Template
          </Button>
        </div>
        <span>Thanks for your interest in Aven System.</span>
        <br />
        <span>
          Please check the box below to indicate you understand and agree to the
          following:
        </span>
        <ol>
          <li>I am the person who is applying for this position.</li>
          <li>
            Responses to all assessments in the application process are my own
            and not prepared by another person or group.
          </li>
          <li>
            I will not use unauthorized materials, websites, or other sources of
            information during this assessment.
          </li>
          <li>
            I will not share the items or other content in this assessment with
            other individuals or groups.
          </li>
          <li>
            I will not consult any other person or group while completing this
            assessment.
          </li>
          <li>
            I understand that any misrepresentation will result in the rejection
            of my application.
          </li>
          <li>
            I understand that if Aven System detects suspicious test-taking
            behavior, they may invalidate my assessment, require additional
            assessments, deem me ineligible for employment, or take legal
            action.
          </li>
        </ol>
        <div className="mt-3">
          <span>Upload Excel/CSV</span>
          <FilePond
            files={files}
            onupdatefiles={handleFile}
            name="file"
            className="mt-2"
            allowMultiple={false}
            instantUpload={false}
          />
          {fileError && (
            <div style={{ color: "red", marginTop: "10px" }}>{fileError}</div>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="success" onClick={handleUploadFile}>
          Upload
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default QuestionImport;
